import { FilterMatchMode } from "primereact/api"
import { tableEnums } from "./tableEnums"
import type { IColumnModel } from "../../../models"
import { getLongestString } from "../../../features/dataFormatFunctions/dataFormatter"
import { getMapHighlightColumn, getMapLinkColumn } from "./tableTemplates/tableColumnTemplates"
import { getItemWebStorage, setItemWebStorage } from "../../../features/webStorageSaver"

export enum TableEvents {
    filter,
    sort,
    page,
}

export const falseTableFilterExpression = '0 eq 1';

export function saveTableStateWebStorage(event: any, key: string) {
    let tablesStateWebStorage = getItemWebStorage("tablesState")
    let tableStatePart: any = {
        [key]: event
    }
    const newTablesStateWebStorage = { ...tablesStateWebStorage, ...tableStatePart }
    setItemWebStorage('tablesState', newTablesStateWebStorage)
}

export function tableStateModifyHandle(state: any, event: TableEvents, setTableStateFunction: any, saveName: any, shouldSave: boolean = true) {
    let table: any = document.querySelector('.p-datatable-wrapper');
    table.scrollTo({ top: 0 });
    if (event === TableEvents.filter || event === TableEvents.sort) {
        state['page'] = 0;
        state['first'] = 0
    }
    if (shouldSave) {
        saveTableStateWebStorage(state, saveName)
    }
    setTableStateFunction(state);
}

export function configureTableLazyState({ first, rows, page, sortField, sortOrder, filters }: any) {
    return {
        first: first ?? 0,
        rows: rows ?? 100,
        page: page ?? 0,
        sortField: sortField ?? null,
        sortOrder: sortOrder ?? null,
        filters: filters ?? null
    }
}

export function defineTableColumnFilterOptions(field: string, type: string, name: string) {
    let filterType = type === 'string' ? FilterMatchMode.CONTAINS : FilterMatchMode.EQUALS
    let filterPlaceholder = `${name} =`
    let filterSelectValues, enumObject
    if (field in tableEnums) {
        filterType = FilterMatchMode.EQUALS
        filterPlaceholder = "Все"
        filterSelectValues = Object.keys(tableEnums[field])
        enumObject = tableEnums[field]
    }
    return { filterType, filterPlaceholder, filterSelectValues, enumObject }
}

export function defineTableFilters(columns: any) {
    let filters: any = {}
    columns?.map((item: any) => {
        filters[item.field] = { value: null, matchMode: item.filterType }
    })
    return filters
}

export function defineTableColumnsFromColumnsStructureObject(columnsStructure: any, canBeFiltered = true, mapColumnType = 'link', textWrap = true, tableValueUrl?: string) {
    let columns: Array<IColumnModel> = []
    if (columnsStructure) {
        columnsStructure && Object.entries(columnsStructure.columns).map(([field, columnOptions]: any) => {
            const { type, width, name, header } = columnOptions ?? {}
            let caption = header ? header : (typeof name === typeof [] ? getLongestString(name) : name)
            const { filterType, filterPlaceholder, filterSelectValues, enumObject }: any = defineTableColumnFilterOptions(field, type, caption)
            let align: any = "left"
            let column: IColumnModel = {
                headerName: caption,
                pdfHeader: caption,
                field,
                valueType: type,
                canBeFiltered: field !== 'MaintenancePosition' && canBeFiltered,
                filterType,
                filterPlaceholder,
                canBeSorted: true,
                showFilterMenu: type !== 'string',
                width,
                align,
                textWrap
            }
            if (filterSelectValues && enumObject) {
                column = { ...column, filterSelectValues, enumObject }
            }
            columns.push(column)
        })
        if (mapColumnType === 'link') {
            const mapLinkColumn: any = getMapLinkColumn()
            columns.push(mapLinkColumn)
        }
        if (mapColumnType === 'highlight') {
            const mapLinkColumn: any = getMapHighlightColumn(tableValueUrl)
            columns.push(mapLinkColumn)
        }
    }
    return columns
}

export function defineTableColumnsFromArray(columnsStructure: any) {
    let columns: Array<IColumnModel> = []
    for (const columnOptions of columnsStructure) {
        let { headerName, headerTemplate, bodyTemplate, field, valueType, canBeFiltered = true, canBeSorted = true, visible = true, align, valueFormat, selectionMode, textWrap = true, shouldBeFormatted = true }: any = columnOptions ?? {}
        const { filterType, filterPlaceholder, filterSelectValues, enumObject }: any = defineTableColumnFilterOptions(field, valueType, headerName)
        let column: IColumnModel = {
            headerName,
            headerTemplate,
            bodyTemplate,
            pdfHeader: headerName,
            field,
            valueType,
            canBeFiltered,
            filterPlaceholder,
            filterType,
            showFilterMenu: valueType !== 'string',
            canBeSorted,
            align,
            visible,
            valueFormat,
            selectionMode,
            shouldBeFormatted,
            textWrap
        }
        if (filterSelectValues && enumObject) {
            column = { ...column, filterSelectValues, enumObject }
        }
        columns.push(column)
    }
    return columns
}